import { Record } from "immutable";
import { EventType } from "models/enumerations/events/event-type";
import { MessageEvent } from "models/interfaces/events/message-event";

const defaultValues: MessageEvent = {
    type: EventType.MessageAction,
    sessionId: "",
    messageEvent: {
        messageId: "",
        action: "",
    },
};

export default class MessageEventRecord
    extends Record(defaultValues)
    implements MessageEvent
{
    constructor(params: Partial<MessageEvent> = {}) {
        super(params ?? defaultValues);
    }
}
